import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { OverChargeClaimSettlement } from '@/views/screens/Claims/types';

import { getOCClaimNextPage } from '../utils/get-next-page';

export const PAGE_SIZE_DEFAULT = 10;

export interface GetOCClaimSettlementsRequestParams {
  fbOcKey: number;
  pageIndex: number;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface OCClaimSettlementsResponse {
  data: OverChargeClaimSettlement[];
  nextPage?: number;
  totalRows: number;
  totalAmount: number;
}

export const getOCClaimSettlementsAPI = (params: GetOCClaimSettlementsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      fbOcKey: params.fbOcKey,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize || PAGE_SIZE_DEFAULT,
      sortColumn: params.sortColumn || 'SettlementSeq',
      sortDirection: params.sortDirection || 'DESC',
    },
    url: `${API.OVERCHARGE_CLAIM}/GetClaimSettlements`,
  });
};

export const fetchOCClaimSettlements = async (
  params: GetOCClaimSettlementsRequestParams,
): Promise<OCClaimSettlementsResponse> => {
  const response: AxiosResponse<OCClaimSettlementsResponse> = await getOCClaimSettlementsAPI(params);
  const data = response.data;
  const pageSize = Number(params.pageSize || PAGE_SIZE_DEFAULT);
  const pageData = data.data ?? [];

  return {
    ...data,
    nextPage: getOCClaimNextPage(Number(params.pageIndex), pageSize, Number(data.totalRows ?? 0), pageData.length),
  };
};
